import React from 'react'
import NewHeader from 'components/layout/Header/index'

const PublicRoute = ({ Component, isHeader, isFooter, child }) => {
  return (
    <>
      {isHeader ? <NewHeader /> : <></>}
      <Component child={child} />
    </>
  )
}

export default PublicRoute
